import { render, staticRenderFns } from "./canceladosquenorenovaron.vue?vue&type=template&id=2208de2d"
import script from "./canceladosquenorenovaron.vue?vue&type=script&lang=js"
export * from "./canceladosquenorenovaron.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports